import "./TrackLogo.css";
import { CaretRightOutlined } from "@ant-design/icons";

const TrackLogo = () => {
  return (
    <div className="track-logo-container">
      <CaretRightOutlined style={{ color: "white", fontSize: 30 }} />
    </div>
  );
};

export default TrackLogo;
